import { Alert, Stack } from '@mui/material'
import PersonIcon from '@mui/icons-material/Person'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import InsertInvitationOutlinedIcon from '@mui/icons-material/InsertInvitationOutlined'
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'
import NotesIcon from '@mui/icons-material/Notes'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import './PrintVisit.sass'
import { getFullNameGuest } from '../../common/utilities/utilities'
import { formatTimeFromJS, getFormateDate, getFormateLastDate } from '../../common/utilities/FormatDate'

const PrintVisit = props => {
  const {
    qr,
    item,
    date,
    entry_time,
    exit_time,
    infoMessage,
    multiDay,
    notes = '',
    hostNotes = '',
    profile,
  } = props

  const { first_name, last_name } = profile
  const { t } = useTranslation()
  const normalizedNotes = notes.trim()
  const normalizedHostNotes = hostNotes.trim()

  return (
    <Stack className='PrintVisit' spacing={4} id='qr-print-area'>
      <Stack direction='row' alignItems='center' spacing={2} mb={4}>
        <PersonIcon sx={{ fontSize: 20 }} />
        <h1>{t('pre_registration_visitor')}</h1>
      </Stack>
      {qr && (
        <div className='qr-wrapper'>
          <img src={qr} alt={t('Access control QR')} />
        </div>
      )}
      <Stack className='qr-info-wrapper' spacing={2}>
        <Stack direction='row' alignItems='center' spacing={2}>
          <AccountCircleOutlinedIcon sx={{ fontSize: 24, color: '#9B9B9B' }} />
          <Stack>
            <span>{t('Visitor')}</span>
            <h3>{getFullNameGuest(item)}</h3>
          </Stack>
        </Stack>
        <Stack direction='row' alignItems='center' spacing={2}>
          <InsertInvitationOutlinedIcon sx={{ fontSize: 24, color: '#9B9B9B' }} />
          <Stack>
            <span>{t('date')}</span>
            <h3>{getFormateDate({ date, multiDay, t })}</h3>
          </Stack>
        </Stack>
        <Stack direction='row' alignItems='center' spacing={2}>
          <ScheduleOutlinedIcon sx={{ fontSize: 24, color: '#9B9B9B' }} />
          <Stack>
            <span>{t('visiting time')}</span>
            <h3>{`${formatTimeFromJS(entry_time)} - ${formatTimeFromJS(exit_time)}`}</h3>
          </Stack>
        </Stack>
        <Stack direction='row' alignItems='center' spacing={2}>
          <PersonOutlineIcon sx={{ fontSize: 24, color: '#9B9B9B' }} />
          <Stack>
            <span>{t('Host')}</span>
            <h3>{`${first_name} ${last_name}`}</h3>
          </Stack>
        </Stack>
        <Stack direction='row' alignItems='center' spacing={2}>
          <ScheduleOutlinedIcon sx={{ fontSize: 24, color: '#9B9B9B' }} />
          <Stack>
            <span>{t('Validity')}</span>
            <h3>{t('valid_until_time', { date: getFormateLastDate({ date, multiDay, t }), time: formatTimeFromJS(exit_time) })}</h3>
          </Stack>
        </Stack>
        {normalizedNotes && (
          <Stack direction='row' alignItems='flex-start' spacing={2} data-qr-reception-notes>
            <NotesIcon sx={{ fontSize: 24, color: '#9B9B9B' }} />
            <Stack className='qr-info-notes'>
              <span>{t('preregistration_reception_notes')}</span>
              <h3>{normalizedNotes}</h3>
            </Stack>
          </Stack>
        )}
        {normalizedHostNotes && (
          <Stack direction='row' alignItems='flex-start' spacing={2}>
            <NotesIcon sx={{ fontSize: 24, color: '#9B9B9B' }} />
            <Stack className='qr-info-notes'>
              <span>{t('Notes for visit')}</span>
              <h3>{normalizedHostNotes}</h3>
            </Stack>
          </Stack>
        )}
      </Stack>
      {qr && (
        <Alert severity='info' variant='outlined' style={{ color: '#1D8099', border: 'none', margin: '10px auto auto auto', width: '382px' }}>
          <span data-qr-download-message>
            {infoMessage || t('You can view the QR again from the reservation details.')}
          </span>
        </Alert>
      )}
    </Stack>
  )
}

const mapStateToProps = state => ({
  profile: state.profile,
})

export default connect(mapStateToProps)(PrintVisit)
